import { Controller } from '../utils/controller';
import { iframeResizer } from 'iframe-resizer';
import productController from './product_controller';

export default class extends Controller {
  static targets = ['output'];
  static requiredTargets = [];

  declare outputTarget: HTMLElement;
  declare readonly hasOutputTarget: boolean;

  // LOCAL STATE
  private resizer: iframeResizer;

  getHeightCalcMethod() {
    const iframeSrc = this.element?.children?.[0]?.src;

    // The 'taggedElement' requires the iframe to contain attribute data-iframe-height="iFrameResizer"
    // The 'bodyScroll' calculates the iframe height with a MutationObserver but the CPU is heavy (VUL-11258)
    return /\/iframe\/|=iframe\//.test(iframeSrc) ? 'taggedElement' : 'bodyScroll';
  }

  initialize() {
    if (this.hasOutputTarget) {
      this.resizer = iframeResizer(
        {
          checkOrigin: false,
          heightCalculationMethod: this.getHeightCalcMethod(),
          log: false,
          tolerance: 50,
          waitForLoad: true,
          warningTimeout: 0,
          onScroll: () => {
            return false;
          },
          onMessage: ({ message }) => {
            const data = typeof message === 'string' ? JSON.parse(message) : message;
            const { scrollY = 0, scrollTarget = '' } = data;
            const action = data?.['_elc_action'] || '';
            const action_name = data?.['_elc_analytics_action_name'] || '';
            const action_label = action_name?.split('_')[1] || '';
            const target = scrollTarget && document.querySelectorAll(scrollTarget);

            switch (action) {
              case 'addtobag':
              case 'addtobagV2': {
                const product = new productController(data.$addBtn);
                product.selectedskuValue = data.skuBaseId;
                product.quantityValue = data.INCREMENT || data.quantity;
                product.iframeId = data.iframeID;
                action === 'addtobag' ? product.addToCart() : product.addToCartV2();
                break;
              }
              case 'selectShade':
                document.getElementById(data.skuBaseId)?.click();
                break;
              case 'scrollIntoView':
                window.scrollTo({
                  top: target?.length ? target[0].offsetTop : scrollY,
                  behavior: 'smooth'
                });
                break;
              case 'openSalesforceChat':
                window?.openSalesforceChat?.();
                break;
              case 'openLiveChat':
                window?.LiveChat?.onBeautyChatButtonClick?.();
                break;
              case 'findationWidget':
                window.dispatchEvent(
                  new CustomEvent('findationWidget', {
                    detail: {
                      event_name: action_name,
                      event_label: action_label
                    }
                  })
                );
                break;
              case 'analyticsIframeEvent':
                window.postMessage(message);
                break;
              default:
                return;
            }
          }
        },
        this.outputTarget
      );
    }

    return this.resizer;
  }
}
